import React, { useState, useEffect } from 'react';
import { Warehouse, Hash } from 'lucide-react';
import Input from '../../components/forms/Input';
import Button from '../../components/ui/Button';

const AlmacenForm = ({ almacen, onSubmit, onCancel, isLoading, isEdit = false }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        codigo: '',
        activo: 1
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEdit && almacen) {
            setFormData({
                nombre: almacen.nombre || '',
                codigo: almacen.codigo || '',
                activo: almacen.activo ? 1 : 0
            });
        }
    }, [isEdit, almacen]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Limpiar error del campo
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombre.trim()) {
            newErrors.nombre = 'El nombre del almacén es requerido';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const dataToSubmit = {
            nombre: formData.nombre.trim(),
            codigo: formData.codigo.trim(),
            activo: parseInt(formData.activo)
        };

        onSubmit(dataToSubmit);
    };

    return (
        <form onSubmit={handleSubmit} className="almacen-form">
            <div className="form-container">
                <div className="form-column">
                    <h3 className="column-title">
                        <Warehouse size={18} />
                        Información del Almacén
                    </h3>

                    <div className="form-group">
                        <Input
                            label="Nombre del Almacén"
                            type="text"
                            value={formData.nombre}
                            onChange={(e) => handleInputChange('nombre', e.target.value)}
                            error={errors.nombre}
                            icon={<Warehouse size={18} />}
                            placeholder="Ej: Almacén Central"
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className="form-group">
                        <Input
                            label="Código"
                            type="text"
                            value={formData.codigo}
                            onChange={(e) => handleInputChange('codigo', e.target.value)}
                            error={errors.codigo}
                            icon={<Hash size={18} />}
                            placeholder="Ej: ALM-001"
                            disabled={isLoading}
                        />
                    </div>

                    {isEdit && (
                        <div className="form-group">
                            <label className="form-label">Estado</label>
                            <div className="toggle-container">
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={formData.activo === 1}
                                        onChange={(e) => handleInputChange('activo', e.target.checked ? 1 : 0)}
                                        disabled={isLoading}
                                    />
                                    <span className="toggle-slider"></span>
                                </label>
                                <span className="toggle-label">
                                    {formData.activo === 1 ? 'Activo' : 'Inactivo'}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Botones de acción */}
            <div className="form-actions">
                <Button
                    type="button"
                    variant="secondary"
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    Cancelar
                </Button>

                <Button
                    type="submit"
                    loading={isLoading}
                    disabled={isLoading}
                >
                    {isEdit ? 'Actualizar Almacén' : 'Crear Almacén'}
                </Button>
            </div>
        </form>
    );
};

export default AlmacenForm;
